const initialState = {
  isLoading: false,
  data: {
    workSessionEditRequests: 0,
    timeOffRequests: 0,
  },
};

export const requestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCHING_REQUESTS':
      return {
        ...state,
        isLoading: true,
      };
    case 'SET_REQUESTS':
      return {
        ...state,
        isLoading: false,
        data: { ...action.payload },
      };
    case 'FETCH_REQUESTS_COMPLETE':
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
